import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';
import Login from './components/Login/Login';
import Unauthorized from './components/Unauthorized/Unauthorized';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import useAutoLogout from './components/AutoLogout/AutoLogout';
import LanguageSwitch from './components/LanguageSwitch/LanguageSwitch';
import AddEmployee from './components/AddEmployee/AddEmployee';
import ShowingReports from './components/ShowingReports/ShowingReports';
import OrgUnits from './components/OrgUnits/OrgUnits';
import Employees from './components/Employees/Employees';


import './i18n/i18n';
import { I18nextProvider } from 'react-i18next';

import Users from './components/Users/Users.jsx';
import Report from './components/Report/Report.jsx';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ThemeProviderComponent } from './context/ThemeContext'; 
import './App.css';

const App = () => {
  const location = useLocation();

  useAutoLogout();
  

  return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <>         
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            
            {/* Protected routes within Layout */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route path="/home" element={<Home />} />
              <Route index element={<Home />} />
              <Route path="/users" element={<Users />} />
              <Route path="/employees" element={<Employees />} />
              <Route path="/report" element={<Report />} />
              <Route path="/addEmployee" element={<AddEmployee />} />
              <Route path="/orgUnits" element={<OrgUnits />} />

            </Route>
            
            {/* Protected route for ShowingReports outside Layout */}
            <Route path="/showingReports" element={
              <ProtectedRoute>
                <ShowingReports /> 
              </ProtectedRoute>
            } />
          </Routes>
        </>
      </LocalizationProvider>
  );
};

export default App;